import React, { useEffect, useState } from 'react';
import MobileNav from '../../component/MobileNav';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getBankVerify, getEsignResponse } from '../../Utils/api';
import { updateJourneyEvents } from '../../CustomerJourneyDetails/CustomerJourneyDetails';
import JourneyRightPanel from '../../component/JourneyRightPannel';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');

  .bd-page * { box-sizing: border-box; margin: 0; padding: 0; }

  .bd-page {
    min-height: 100vh;
    background: #eaf1fd;
    display: flex;
    flex-direction: column;
    font-family: 'Sora', sans-serif;
  }

  .bd-split {
    display: grid;
    grid-template-columns: 1fr 1fr;
    flex: 1;
    min-height: calc(100vh - 60px);
    margin-top: 50px;
  }

  /* ── LEFT ── */
  .bd-left {
    display: flex;
    flex-direction: column;
    padding: 2rem 2.5rem;
    background: #eaf1fd;
    overflow-y: auto;
  }

  .bd-logo {
    display: flex; align-items: center; gap: 10px;
    margin-bottom: 1.5rem; flex-shrink: 0;
  }
  .bd-logo-dot {
    width: 34px; height: 34px; background: #F97316;
    border-radius: 10px; display: flex; align-items: center; justify-content: center;
  }
  .bd-logo-dot svg { width: 18px; height: 18px; fill: none; stroke: #fff; stroke-width: 2.2; stroke-linecap: round; }
  .bd-logo-name { font-size: 16px; font-weight: 600; color: #0f1c2e; letter-spacing: -0.2px; }

  .bd-card {
    background: #fff;
    border-radius: 24px;
    padding: 1.25rem 1.5rem;
    box-shadow: 0 4px 40px rgba(15,28,46,0.08), 0 1px 4px rgba(15,28,46,0.04);
    border: 1px solid rgba(255,255,255,0.8);
  }

  .bd-card-title { font-size: 22px; font-weight: 700; color: #0f1c2e; letter-spacing: -0.5px; margin-bottom: 4px; }
  .bd-card-sub { font-size: 13px; color: #6b7a90; margin-bottom: 2rem; }

  /* SECTION */
  .bd-section { margin-bottom: 1.75rem; }
  .bd-section-title {
    font-size: 11px; font-weight: 600; letter-spacing: 0.7px;
    text-transform: uppercase; color: #9aaabb;
    margin-bottom: 1rem;
    display: flex; align-items: center; gap: 8px;
  }
  .bd-section-title::after { content: ''; flex: 1; height: 1px; background: #e8eef7; }

  /* GRID */
  .bd-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.25rem;
    margin-bottom: 1.25rem;
  }
  .bd-row.single { grid-template-columns: 1fr; }

  /* FIELD LABEL */
  .bd-field-label {
    font-size: 11px; font-weight: 600; letter-spacing: 0.5px;
    text-transform: uppercase; color: #6b7a90;
    margin-bottom: 8px; display: block;
  }

  /* READONLY INPUT */
  .bd-input-wrap { position: relative; }
  .bd-input-icon {
    position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
    color: #9aaabb; pointer-events: none;
    display: flex; align-items: center;
  }
  .bd-input-icon svg { width: 16px; height: 16px; }
  .bd-input {
    width: 100%; height: 46px;
    border: 1.5px solid #dce4f0; border-radius: 12px;
    background: #f0f4fa;
    padding: 0 40px 0 38px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 13px; font-weight: 500; color: #4a5568;
    outline: none; cursor: not-allowed;
  }
  .bd-input.masked { letter-spacing: 2px; }
  .bd-auto-badge {
    position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
    background: #e8eef7; border-radius: 5px;
    padding: 2px 7px; font-size: 10px; color: #9aaabb;
    font-weight: 500; font-family: 'Sora', sans-serif;
  }

  /* VERIFIED STRIP */
  .bd-verified-strip {
    display: flex; align-items: center; gap: 10px;
    background: rgba(52,211,153,0.06);
    border: 1px solid rgba(52,211,153,0.25);
    border-radius: 14px; padding: 12px 16px;
    margin-bottom: 1.25rem;
  }
  .bd-verified-icon {
    width: 32px; height: 32px; border-radius: 8px;
    background: rgba(52,211,153,0.15);
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .bd-verified-icon svg { width: 16px; height: 16px; fill: none; stroke: #34d399; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
  .bd-verified-text { font-size: 12.5px; color: #2d6a4f; font-weight: 500; }
  .bd-verified-text span { font-size: 11.5px; color: #6b7a90; font-weight: 400; display: block; margin-top: 1px; }

  /* CTA */
  .bd-cta {
    width: 100%; height: 50px;
    border: none; border-radius: 14px;
    background: #F97316; color: #fff;
    font-family: 'Sora', sans-serif;
    font-size: 15px; font-weight: 600;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center; gap: 8px;
    transition: background 0.18s, transform 0.1s, box-shadow 0.18s;
    box-shadow: 0 4px 18px rgba(249,115,22,0.32);
    margin-top: 1.25rem;
  }
  .bd-cta:hover:not(:disabled) {
    background: #ea6a0a;
    box-shadow: 0 6px 24px rgba(249,115,22,0.42);
    transform: translateY(-1px);
  }
  .bd-cta:active:not(:disabled) { transform: scale(0.98); }
  .bd-cta:disabled { background: #c8d3e2; box-shadow: none; cursor: not-allowed; }

  /* TRUST */
  .bd-trust {
    display: flex; align-items: center; justify-content: center;
    gap: 6px; margin-top: 1.25rem;
    font-size: 11.5px; color: #9aaabb;
  }
  .bd-trust svg { width: 13px; height: 13px; }
  .bd-trust-sep { width: 3px; height: 3px; background: #c8d3e2; border-radius: 50%; margin: 0 2px; }

  /* FULL-SCREEN LOADER */
  .bd-loader-overlay {
    position: fixed; inset: 0;
    background: rgba(255,255,255,0.9);
    display: flex; align-items: center; justify-content: center;
    z-index: 9999; backdrop-filter: blur(4px);
  }
  .bd-loader-box {
    display: flex; flex-direction: column; align-items: center; gap: 16px;
    padding: 1.5rem 2rem;
    background: #fff; border-radius: 20px;
    box-shadow: 0 8px 40px rgba(15,28,46,0.14);
    border: 1px solid #e8eef7;
    text-align: center;
  }
  .bd-loader-spinner {
    width: 44px; height: 44px;
    border: 3px solid #e0e9f5;
    border-top-color: #F97316;
    border-radius: 50%;
    animation: bd-spin 0.7s linear infinite;
  }
  @keyframes bd-spin { to { transform: rotate(360deg); } }
  .bd-loader-title { font-size: 15px; font-weight: 600; color: #0f1c2e; }
  .bd-loader-sub { font-size: 12px; color: #6b7a90; max-width: 220px; line-height: 1.5; }

  /* RESPONSIVE */
  @media (max-width: 900px) {
    .bd-split { grid-template-columns: 1fr; }
    .bd-left { padding: 2rem 1.25rem 6rem; }
    .bd-logo { margin-bottom: 1.5rem; }
    .bd-card { padding: 1.75rem 1.5rem; }
    .bd-row { grid-template-columns: 1fr; }
  }
  @media (max-width: 400px) {
    .bd-card { padding: 1.5rem 1.25rem; }
  }
`;

// ── Icons ──
const IconBolt = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
  </svg>
);
const IconBank = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="22" x2="21" y2="22"/>
    <line x1="6" y1="18" x2="6" y2="11"/>
    <line x1="10" y1="18" x2="10" y2="11"/>
    <line x1="14" y1="18" x2="14" y2="11"/>
    <line x1="18" y1="18" x2="18" y2="11"/>
    <polygon points="12 2 20 7 4 7"/>
  </svg>
);
const IconHash = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="4" y1="9" x2="20" y2="9"/>
    <line x1="4" y1="15" x2="20" y2="15"/>
    <line x1="10" y1="3" x2="8" y2="21"/>
    <line x1="16" y1="3" x2="14" y2="21"/>
  </svg>
);
const IconCode = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6"/>
    <polyline points="8 6 2 12 8 18"/>
  </svg>
);
const IconUser = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);
const IconCheck = () => (
  <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
);

const IconLock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);
const IconMapPin = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const ACCOUNT_NUMBER_REGEX = /^[0-9]{9,18}$/;
const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;

// Readonly field sub-component
const ReadonlyField = ({
  label,
  value,
  icon,
  masked,
  editable = false,
  onChange,
  name,
  maxLength,
}) => (
  <div>
    <label className="bd-field-label">{label}</label>

    <div className="bd-input-wrap">
      <span className="bd-input-icon">{icon}</span>

      <input
        type="text"
        className={`bd-input ${masked ? 'masked' : ''}`}
        value={value || ''}
        readOnly={!editable}
        onChange={onChange}
        name={name}
        maxLength={maxLength}
        autoComplete="off"
        aria-label={label}
        style={{
          cursor: editable ? 'text' : 'not-allowed',
          background: editable ? '#fff' : '#f0f4fa',
          color: editable ? '#0f1c2e' : '#4a5568',
        }}
      />

      {!editable && <span className="bd-auto-badge">auto</span>}
    </div>
  </div>
);

const BankTypeField = ({
  value,
  editable,
  onChange,
}) => (
  <div>
    <label className="bd-field-label">Bank Type</label>

    {editable ? (
      <select
        className="bd-input"
        name="accountTypeId"
        value={value}
        onChange={onChange}
        style={{
          background: '#fff',
          cursor: 'pointer',
          paddingLeft: '12px',
          fontFamily: 'Sora',
        }}
      >
        <option value="">---- Choose Bank Type ----</option>
        <option value="1">SAVING</option>
        <option value="2">CURRENT</option>
        <option value="3">SALARY</option>
        <option value="4">FIXED</option>
        <option value="5">RECURRING</option>
      </select>
    ) : (
      <div className="bd-input-wrap">
        <input
          className="bd-input"
          readOnly
          value={
            {
              1: 'SAVING',
              2: 'CURRENT',
              3: 'SALARY',
              4: 'FIXED',
              5: 'RECURRING',
            }[value] || ''
          }
        />
        <span className="bd-auto-badge">auto</span>
      </div>
    )}
  </div>
);

// Mask account number — show only last 4 digits
const maskAccount = (acc) => {
  if (!acc) return '—';
  const str = String(acc);
  return '•'.repeat(Math.max(0, str.length - 4)) + str.slice(-4);
};

export default function BankDetails() {
  const [isVerifying, setIsVerifying] = useState(false);
  const customerDetails = useSelector((state) => state.customerJourneyDetails.customerDetails);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const utm_source = customerDetails?.utm_source;
  const [errors, setErrors] = useState({});


//   useEffect(() => {
//   const leadId = customerDetails?.lead_id;

  

//   const hitApi = async () => {
//     try {
//     const response = await getEsignResponse(leadId);

//     console.log('eSign API Status:', response.status);

//     if (response.status === 200) {
//       console.log('eSign API success');
//     }
//   } catch (error) {
//     console.error('eSign API Error:', error);
//   }
//   };

//   hitApi();
// }, []);

useEffect(() => {
  const handleEkyc = async () => {
    const leadId = customerDetails?.lead_id;
    const param={lead_id:leadId}

      if (leadId) {
        try {
          const ekycResponse = await getEsignResponse(param);

          if (ekycResponse?.data?.Status === 1) {
            
            dispatch(updateJourneyEvents({
              account_aggregator: 2,
              banking_details: 1
            }));

          }
        } catch (error) {
          console.error("Error fetching esign response:", error);
        }
      }
    
  };

  handleEkyc();
}, [dispatch]);


  const submit = async () => {
  if (isVerifying) return;

  const validationErrors = {};

  if (!formData.bankName?.trim()) {
    validationErrors.bankName = "Bank name is required";
  }

  if (!formData.branch?.trim()) {
    validationErrors.branch = "Branch name is required";
  }

  if (!formData.ifscCode?.trim()) {
    validationErrors.ifscCode = "IFSC code is required";
  } else if (!IFSC_REGEX.test(formData.ifscCode)) {
    validationErrors.ifscCode =
      "Invalid IFSC format (e.g. HDFC0001234)";
  }

  if (!formData.bankAccountNo) {
    validationErrors.bankAccountNo =
      "Account number is required";
  } else if (!ACCOUNT_NUMBER_REGEX.test(formData.bankAccountNo)) {
    validationErrors.bankAccountNo =
      "Account number must be 9-18 digits";
  }

  if (!formData.confirmBankAccountNo) {
    validationErrors.confirmBankAccountNo =
      "Please confirm account number";
  } else if (
    formData.bankAccountNo !==
    formData.confirmBankAccountNo
  ) {
    validationErrors.confirmBankAccountNo =
      "Account numbers do not match";
  }

  if (!formData.accountTypeId) {
    validationErrors.accountTypeId =
      "Please select account type";
  }

  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);

    const firstError = Object.values(validationErrors)[0];
    toast.error(firstError);

    return;
  }

  if (String(formData.accountTypeId) !== "1") {
    toast.error("Only Saving Bank Account is allowed");
    return;
  }

  const param = {
    profileId: customerDetails?.profileId,
    bankAccountNo: formData.bankAccountNo.trim(),
    confirmBankAccountNo:
      formData.confirmBankAccountNo.trim(),
    ifscCode: formData.ifscCode.trim(),
    accountTypeId: formData.accountTypeId,
  };

  setIsVerifying(true);

  try {
    const response = await getBankVerify(param);

    if (response?.data?.apiStatus === 1) {
      if (response?.data?.data?.go_to_esign === 1) {
        window.location.replace(
          response?.data?.data?.url
        );
        return;
      }

      dispatch(
        updateJourneyEvents({
          banking_details: 1,
        })
      );

      navigate("/journey/congratulations");
    } else {
      toast.error(
        response?.data?.message ||
          "Something went wrong"
      );
    }
  } catch {
    toast.error(
      "Error while verifying bank details"
    );
  } finally {
    setIsVerifying(false);
  }
};

  const data = customerDetails?.data || {};
  const isBankDataComplete =
  data.bankName &&
  data.branch &&
  data.ifscCode &&
  data.bankAccountNo &&
  data.confirmBankAccountNo &&
  data.accountTypeId;

const [formData, setFormData] = useState({
  bankName: data.bankName || '',
  branch: data.branch || '',
  ifscCode: data.ifscCode || '',
  bankAccountNo: data.bankAccountNo || '',
  confirmBankAccountNo: data.confirmBankAccountNo || '',
  accountTypeId: data.accountTypeId || '',
});

const handleChange = (e) => {
  const { name, value } = e.target;

  let updatedValue = value;

  switch (name) {
    case "bankAccountNo":
    case "confirmBankAccountNo":
      updatedValue = value.replace(/\D/g, "").slice(0, 18);
      break;

    case "ifscCode":
      updatedValue = value
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, 11);
      break;

    case "bankName":
      updatedValue = value
        .replace(/[^a-zA-Z\s.&]/g, "")
        .slice(0, 100);
      break;

    case "branch":
      updatedValue = value
        .replace(/[^a-zA-Z0-9\s.,()-]/g, "")
        .slice(0, 100);
      break;

    default:
      break;
  }

  setFormData((prev) => ({
    ...prev,
    [name]: updatedValue,
  }));

  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
};

  return (
    <>
      <style>{styles}</style>
      <div className="bd-page">
        <div className="bd-split">

          {/* ── LEFT: FORM ── */}
          <div className="bd-left">
            

            <div className="bd-card">
              <h1 className="bd-card-title">Bank details</h1>
              <p className="bd-card-sub">Your bank details have been fetched securely. Please review and confirm.</p>

              {/* VERIFIED STRIP */}
              <div className="bd-verified-strip">
                <div className="bd-verified-icon"><IconCheck /></div>
                <div className="bd-verified-text">
                  Bank account verified
                  <span>Details auto-fetched via secure banking API</span>
                </div>
              </div>

              {/* BANK INFO */}
              <div className="bd-section">
                <div className="bd-section-title">Bank information</div>

                <div className="bd-row single" style={{ marginBottom: '1.25rem' }}>
                  <ReadonlyField
                  label="Bank name"
                  value={formData.bankName}
                  icon={<IconBank />}
                  editable={!isBankDataComplete}
                  name="bankName"
                  maxLength={100}
                  onChange={handleChange}
                />

                {errors.bankName && (
                  <p style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>
                    {errors.bankName}
                  </p>
                )}
                </div>

                <div className="bd-row">
                  <ReadonlyField
                    label="Branch name"
                    value={formData.branch}
                    icon={<IconMapPin />}
                    editable={!isBankDataComplete}
                    name="branch"
                    maxLength={100}
                    onChange={handleChange}
                  />

                  {errors.branch && (
                    <p style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>
                      {errors.branch}
                    </p>
                  )}
                  <ReadonlyField
                    label="IFSC code"
                    value={formData.ifscCode}
                    icon={<IconCode />}
                    editable={!isBankDataComplete}
                    name="ifscCode"
                    maxLength={11}
                    onChange={handleChange}
                  />

                  {errors.ifscCode && (
                    <p style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>
                      {errors.ifscCode}
                    </p>
                  )}
                </div>
              </div>

              {/* ACCOUNT INFO */}
              <div className="bd-section">
                <div className="bd-section-title">Account details</div>
                <div className="bd-row">
                  <ReadonlyField
                    label="Account number"
                    value={
                      isBankDataComplete
                        ? maskAccount(formData.bankAccountNo)
                        : formData.bankAccountNo
                    }
                    icon={<IconHash />}
                    editable={!isBankDataComplete}
                    name="bankAccountNo"
                    maxLength={18}
                    onChange={handleChange}
                    masked={isBankDataComplete}
                  />

                  {errors.bankAccountNo && (
                    <p style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>
                      {errors.bankAccountNo}
                    </p>
                  )}
                  <ReadonlyField
                  label="Confirm account"
                  value={
                    isBankDataComplete
                      ? maskAccount(formData.confirmBankAccountNo)
                      : formData.confirmBankAccountNo
                  }
                  icon={<IconUser />}
                  editable={!isBankDataComplete}
                  name="confirmBankAccountNo"
                  maxLength={18}
                  onChange={handleChange}
                  masked={isBankDataComplete}
                />

                {errors.confirmBankAccountNo && (
                  <p style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>
                    {errors.confirmBankAccountNo}
                  </p>
                )}
                </div>
                <div className="bd-row single">
                  <BankTypeField
                    value={formData.accountTypeId}
                    editable={!isBankDataComplete}
                    onChange={handleChange}
                  />
                  
                </div>
                {formData.accountTypeId &&
                  String(formData.accountTypeId) !== "1" && (
                    <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "6px" }}>
                      Only Saving Bank Account is allowed.
                    </p>
                )}
              </div>

              {/* CTA */}
             <button
                className="bd-cta"
                onClick={submit}
                disabled={isVerifying || String(formData.accountTypeId) !== "1"}
              >
                {isVerifying ? (
                  <>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
                      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83">
                        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/>
                      </path>
                    </svg>
                    Processing…
                  </>
                ) : (
                  <>Confirm &amp; continue </>
                )}
              </button>

              <div className="bd-trust">
                <IconLock />
                256-bit SSL encrypted
                <span className="bd-trust-sep" />
                Your data is private
                <span className="bd-trust-sep" />
                RBI compliant
              </div>
            </div>
          </div>

          {/* ── RIGHT: reusable component ── */}
          <JourneyRightPanel />

        </div>
      </div>

      <MobileNav />

      {/* FULL SCREEN LOADER */}
      {isVerifying && (
        <div className="bd-loader-overlay">
          <div className="bd-loader-box">
            <div className="bd-loader-spinner" />
            <div className="bd-loader-title">Verifying your bank account</div>
            <div className="bd-loader-sub">Please wait a few seconds. Do not refresh or close the page.</div>
          </div>
        </div>
      )}
    </>
  );
}